import React, { useEffect, useState } from "react";
import styles from "./Organisation.module.css";
import TrainLoader from "../Loader/Loader";

const JodhpurDivison = () => {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(
      "https://opensheet.elk.sh/19NfX14cD73sQGqk8yCiOjks_hfWvLJDDvmZVUw0G_pM/JodhpurDivision"
    )
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        const allKeys = new Set();
        json.forEach((row) => {
          Object.keys(row).forEach((key) => allKeys.add(key));
        });
        const headerArray = Array.from(allKeys);
        const sortedHeaders = [
          "Unit",
          ...headerArray.filter((h) => h !== "Unit"),
        ];
        setHeaders(sortedHeaders);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to load data.");
        setLoading(false);
      });
  }, []);

  if (loading) return <TrainLoader />;
  if (error) return <p className={styles.error}>{error}</p>;

  return (
    <div className={styles.TableContainer}>
      <table className={styles.membersTable}>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header) => {
                const value = row[header];
                if (!value) return <td key={header}> </td>;

                // Try to split name and phone
                const match = value.match(/^(.+?)\s+(\d{10})$/);
                if (match) {
                  return (
                    <td key={header}>
                      <div>{match[1]}</div>
                      <div>{match[2]}</div>
                    </td>
                  );
                }

                return <td key={header}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JodhpurDivison;
